import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsReviewStatusReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'reviewStatusReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/review_status_reports',
        { review_status_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
